import { action, computed, observable, toJS } from 'mobx';
import { observer } from 'mobx-react';
import Slider, { SliderTooltip } from 'rc-slider';
import * as React from 'react';
import { bind } from '../Utils/Bind';
import { componentReaction } from '../Utils/MobxTools';

const Handle = Slider.Handle as any;

export interface ISliderProps {
    formatTooltip?(v: number): string;
    onChange?(v: number): void;
    readonly loading?: boolean;
    readonly className?: string;
    readonly min: number;
    readonly max: number;
    readonly steps: number;
    readonly disabled?: boolean;
    readonly tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
    initialValue?: number;
}

@observer
export class ReactSlider extends React.Component<ISliderProps> {
    public constructor(props: ISliderProps) {
        super(props);
        componentReaction(this, () => this.props.max, this.updateValue);
        this.setInitialValue();
    }
    public render() {
        return (
            <div className={this.props.className}>
                <Slider
                    min={this.props.min}
                    max={this.props.max}
                    step={this.props.steps}
                    onBeforeChange={this.onBeforeChange}
                    onAfterChange={this.onAfterChange}
                    onChange={this.onChange}
                    included={false}
                    handle={props => {
                        const { value, dragging, index, ...restProps } = props;
                        return (
                            <SliderTooltip
                                prefixCls="rc-slider-tooltip"
                                overlay={this.props.formatTooltip ? this.props.formatTooltip(value) : value}
                                visible={dragging}
                                placement="top"
                                key={index}
                            >
                                <Handle {...restProps} value={value} />
                            </SliderTooltip>
                        );
                    }}
                    defaultValue={this.props.initialValue ? this.props.initialValue : this.props.max}
                    value={this.sliding ? this.slidingValue : this.value}
                    disabled={this.props.disabled}
                    railStyle={{
                        backgroundColor: 'rgba(45, 139, 163, 0.5)',
                    }}
                    dotStyle={{ borderColor: '#2d8ba3' }}
                />
            </div>
        );
    }

    @bind
    @action
    private updateValue() {
        this.value = this.props.max;
    }

    @bind
    @action
    private setInitialValue() {
        this.value = this.props.initialValue ? this.props.initialValue : this.props.max;
    }

    @bind
    @action
    private onChange(value: number) {
        this.slidingValue = value;
    }

    @bind
    @action
    private onBeforeChange(value: number) {
        this.sliding = true;
    }

    @bind
    @action
    private onAfterChange(value: number) {
        this.sliding = false;

        this.value = value;
        if (this.props.onChange) this.props.onChange(value);
    }

    @observable
    private value?: number;

    @observable
    private slidingValue?: number;

    @observable
    private sliding: boolean = false;
}
